import React from 'react'

import { Grid, GridProps } from '@material-ui/core'
import clsx from 'clsx'

import translate from '~/locale'

export type CardRowItemProps = {
  image: string
  imageAlt?: string
  title?: string
  titleColor?: 'black' | 'primary'
  icon?: React.ComponentType<{ height: number; className: string }>
  text: string
} & GridProps

const CardRowItem: React.FC<CardRowItemProps> = ({
  titleColor = 'black',
  image,
  imageAlt,
  title,
  icon: Icon,
  text,
  ...rest
}) => {
  return (
    <Grid item {...rest}>
      <div className="card h-100 bg-white shadow-xxl card-box-hover-rise mb-2">
        <img src={image} className="card-img-top" alt={imageAlt} />
        <div className="p-3 rounded-bottom p-xl-4">
          {title && (
            <div
              className={clsx(
                'font-weight-bold font-size-lg d-flex align-items-center',
                {
                  'text-black': titleColor === 'black',
                  'text-primary': titleColor === 'primary',
                },
              )}
            >
              {Icon && <Icon height={35} className="mr-2" />}
              <span>{translate(title)}</span>
            </div>
          )}
          <p className="text-second opacity-8 mt-4 mb-0">{translate(text)}</p>
        </div>
      </div>
    </Grid>
  )
}

export default CardRowItem
